import { __assign } from "tslib";
var REQUEST_ID_HEADER = 'x-wix-request-id';
var addMetadata = function (req) {
    var _a;
    return (__assign(__assign({}, req.data), { metadata: { requestId: (_a = req === null || req === void 0 ? void 0 : req.headers) === null || _a === void 0 ? void 0 : _a[REQUEST_ID_HEADER] } }));
};
export var createAxiosHttpAdapter = function (httpClient, externalHeaders) {
    var http = {
        get: function (url, headers, includeMetadata) { return httpClient.get(url, { headers: __assign(__assign({}, headers), externalHeaders) })
            .then(function (req) { return includeMetadata ? addMetadata(req) : req.data; }); },
        // tslint:disable-next-line:max-line-length
        post: function (url, body, headers, onUploadProgress, includeMetadata) { return httpClient.post(url, body, {
            onUploadProgress: onUploadProgress,
            headers: __assign(__assign({}, headers), externalHeaders)
        }).then(function (req) { return includeMetadata ? addMetadata(req) : req.data; }); },
        put: function (url, body, headers, _onUploadProgress, includeMetadata) { return httpClient.put(url, body, { headers: __assign(__assign({}, headers), externalHeaders) })
            .then(function (req) { return includeMetadata ? addMetadata(req) : req.data; }); },
        delete: function (url, headers, includeMetadata) { return httpClient.delete(url, { headers: __assign(__assign({}, headers), externalHeaders) })
            .then(function (req) { return includeMetadata ? addMetadata(req) : req.data; }); },
    };
    return http;
};
//# sourceMappingURL=base-http-client-adapter.js.map